import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { routes } from "../../../helper/routes";
import edfocilogo from "../../../assets/images/logo.png";
import edsiderlogowhite from "../../../assets/images/edsiderlogowhite.png"
import cmclogo from "../../../assets/images/mid.png"
import RAlogo from "../../../assets/images/royal-logo.png"
import CGClogo from "../../../assets/images/cgc-logo.png";
import { HiBellAlert, HiShoppingCart } from 'react-icons/hi2';
import './sidebar.css';
import config from '../../../helper/config';
import { customerConstants } from "../../../helper/constants.js";
import UserProfile from './UserProfile.js';
import NotificationDropdown from './NotificationDropdown.js';
import { useCart } from '../../../context/cart/CartContext';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};
const customer = getCustomerFeatureFlag();
let logo, logoStyle;

switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    logo = edsiderlogowhite;
    logoStyle = { width: "140px", height: "auto" };
    break;
  case customerConstants.EXO_CUSTOMER2:
    logo = cmclogo;
    logoStyle = { width: "140px", height: "auto" };
    break;
  case customerConstants.EDF_CUSTOMER2:
    logo = RAlogo;
    logoStyle = { width: "40px", height: "auto" };
    break;
  case customerConstants.EDF_CUSTOMER3:
    logo = CGClogo;
    logoStyle = { width: "40px", height: "auto" };
    break;
  default:
    logo = edfocilogo;
    logoStyle = { width: "140px", height: "auto" };
    break;
}

export default function HeaderMobile(props) {

  const history = useHistory();
  const { cartItemCount } = useCart();
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const [isNotificationsOpen, setNotificationsOpen] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);
  const [isTeacher, setIsTeacher] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isParent, setIsParent] = useState(false)

  // Add toggle handler
  const toggleOffcanvas = () => {
    setOffcanvasOpen(!isOffcanvasOpen);
  };

  useEffect(() => {
    if (window.KTLayoutAside) window.KTLayoutAside.init('kt_aside');
    if (window.KTLayoutHeaderTopbar) window.KTLayoutHeaderTopbar.init('kt_header_mobile_topbar_toggle');
    let isAdmin = sessionStorage.getItem("userType") === "admin";
    let isTeacher = sessionStorage.getItem("userType") === "teacher";
    let isStudent = sessionStorage.getItem("userType") === "student";
    let isParent = sessionStorage.getItem("userType") === "parent";
    setIsAdmin(isAdmin);
    setIsTeacher(isTeacher);
    setIsStudent(isStudent);
    setIsParent(isParent)
  }, []);

  const toggleNotifications = () => {
    setNotificationsOpen(!isNotificationsOpen);
  };

  const goToCart = () => {
    history.push(routes.my_cart);
  };

  return (
    <div style={{ position: 'relative' }}>

      {isOffcanvasOpen && (
        <div
          className="offcanvas-overlay show"
          onClick={() => setOffcanvasOpen(false)}
        />
      )}

      <div id="kt_header_mobile" className="header-mobile align-items-center header-mobile-fixed" >
        <div className="brand-logo">
          <img alt="Logo" className="logo" src={logo} />
        </div>
        <div className="d-flex align-items-center">
          <button
            className="tmh-icon-btn ml-2 cart-icon"
            id="kt_header_mobile_cart_toggle"
            onClick={goToCart}
            aria-label="Open cart"
            title="Cart"
          >
            <HiShoppingCart className="tmh-icon cart-icon__icon" />
            {cartItemCount > 0 && (
              <span className="cart-badge">{cartItemCount > 99 ? '99+' : cartItemCount}</span>
            )}
          </button>

          <button
            className="tmh-icon-btn tmh-notification-btn ml-2 notification-icon"
            id="kt_header_mobile_notifications_toggle"
            onClick={toggleNotifications}
            aria-label="Open notifications"
            title="Notifications"
          >
            <HiBellAlert className="tmh-icon notification-icon__icon" />
          </button>

          <button
            className="tmh-icon-btn"
            id="kt_header_mobile_toggle"
            onClick={props.onMobileMenuToggle}
          >
            <svg
              className="tmh-icon"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              aria-hidden="true"
            >
              <path d="M3 6h18v2H3zM3 11h18v2H3zM3 16h18v2H3z"></path>
            </svg>
          </button>

          <button
            className="tmh-icon-btn tmh-profile-btn  ml-2"
            id="kt_header_mobile_topbar_toggle"
            onClick={toggleOffcanvas} // Add onClick handler

            aria-label="Open profile"
            title="Profile"
          >
            {/* Profile/user icon (SVG) */}
            <svg
              className="tmh-icon"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              aria-hidden="true"
            >
              <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5z"></path>
            </svg>
          </button>

        </div>
      </div>

      <div
        id="kt_header_mobile_topbar"
        className={`offcanvas offcanvas-right p-10 ${isOffcanvasOpen ? 'offcanvas-on' : ''}`}
      >
        <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
          <h3 className="font-weight-bold m-0">User Profile</h3>
          <a
            href="#"
            className="btn btn-xs btn-icon btn-light btn-hover-primary"
            id="kt_header_mobile_topbar_close"
            onClick={(e) => {
              e.preventDefault();
              setOffcanvasOpen(false);
            }}
          >
            <i className="ki ki-close icon-xs text-muted"></i>
          </a>
        </div>

        <div className="offcanvas-content">
          {isOffcanvasOpen && <UserProfile isMobileView={true} />} {/* Only render when offcanvas is open */}
        </div>
      </div>

      {/* Notifications dropdown for mobile */}
      <NotificationDropdown
        isOpen={isNotificationsOpen}
        onClose={() => setNotificationsOpen(false)}
      />
    </div>
  )
}
